// The one import site for `cally`. Both booking controllers
// come through here, and nothing else may import the
// package directly (a spec pins that).
//
// cally registers five custom elements at module scope,
// `calendar-ctx`, `calendar-month`, `calendar-date`,
// `calendar-range` and `calendar-multi`, and
// `customElements.define` throws a NotSupportedError on a
// name the registry already holds. A document evaluates a
// module once, so two controllers importing it cannot cause
// that between them. A second copy of the WHOLE BUNDLE can,
// which is what CAL-504 found in production: a deploy's new
// entry chunk was appended into a live page, every module
// in it ran again, and `calendar-ctx` threw first only
// because it is the first define in the file.
//
// THIS IS DEFENCE IN DEPTH, NOT THE FIX. The cause was
// `data_turbo_track:` in all 11 layouts, an attribute Turbo
// does not read, so asset tracking never reloaded a page
// whose bundle had moved underneath it. That is fixed in
// the same ticket, and with it a second evaluation should
// not happen at all. What stays true here regardless is
// that a package registering custom elements at module
// scope cannot survive one, however it arrives.
//
// The order of the two imports below is the mechanism, not
// a formatting choice. Do not sort them.
import { restoreCustomElementDefine } from "./skip_registered_custom_elements";
import "cally";

restoreCustomElementDefine();
